export default __webpack_public_path__ + "static/media/STLNewspaperCovering.c3888a62.pdf";